export class SearchInput {
    'cloudProvider';
    'startDate';
    'endDate';
    'limit';
    'queryExecutionId';
    'pageToken';
    'query';
    'filters';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "limit",
            "baseName": "limit",
            "type": "number",
            "format": ""
        },
        {
            "name": "queryExecutionId",
            "baseName": "queryExecutionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "pageToken",
            "baseName": "pageToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "filters",
            "baseName": "filters",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchInput.attributeTypeMap;
    }
    constructor() {
    }
}
